import { Input } from '../../../components/ui/Input.jsx';
import { Button } from '../../../components/ui/Button.jsx';

/**
 * Free key/value editor for variant attributes (e.g. Peso, Gusto, Colore...).
 * `value` is a plain object; `onChange` receives the updated object. Rows are
 * kept as an ordered list so editing a key does not lose the row.
 */
export function AttributesEditor({ value = {}, onChange, label = 'Attributi variante' }) {
  const rows = Object.entries(value);

  const setRows = (next) => {
    const obj = {};
    next.forEach(([k, v]) => { if (k.trim()) obj[k.trim()] = v; });
    onChange(obj);
  };

  const updateKey = (idx, key) => setRows(rows.map((r, i) => (i === idx ? [key, r[1]] : r)));
  const updateVal = (idx, val) => setRows(rows.map((r, i) => (i === idx ? [r[0], val] : r)));
  const remove = (idx) => setRows(rows.filter((_, i) => i !== idx));
  const add = () => onChange({ ...value, '': '' });

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-ink">{label}</span>
        <Button type="button" variant="secondary" size="sm" onClick={add}>Aggiungi attributo</Button>
      </div>
      {rows.length === 0 ? (
        <p className="text-sm text-ink-faint">Nessun attributo. Es. Peso = 2kg, Gusto = Salmone.</p>
      ) : (
        <div className="flex flex-col gap-2">
          {rows.map(([k, v], i) => (
            <div key={i} className="grid grid-cols-1 items-end gap-2 sm:grid-cols-12">
              <div className="sm:col-span-5"><Input label={i === 0 ? 'Attributo' : undefined} placeholder="es. peso" value={k} onChange={(e) => updateKey(i, e.target.value)} /></div>
              <div className="sm:col-span-6"><Input label={i === 0 ? 'Valore' : undefined} placeholder="es. 2kg" value={v} onChange={(e) => updateVal(i, e.target.value)} /></div>
              <div className="sm:col-span-1"><Button type="button" variant="ghost" onClick={() => remove(i)}>✕</Button></div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
